import Page from "components/Page";
import React, { useEffect, useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { Suspense } from "react";
import Loader from "components/Loader";
import styles from "../Appointments.module.scss";
import alertImage from "../../../../assets/images/alert-circle-black.svg";
import crossIcon from "../../../../assets/images/mir_cross grey.svg";
import Text from "components/Text";
import constants from "../../../../constants";
import { decodeId, encodeId, getStorage, setStorage } from "utils";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import PatientList from "./PatientList";
import Card from "components/Card";
import { Link } from "react-router-dom/cjs/react-router-dom";
import {
  useOfficeDetail,
  useStaffByUserId,
} from "repositories/office-repository";
import { useSelector } from "react-redux";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
const tabsEnabled = {
  mypatient: 1,
  otherDoctors: 2,
  both: 3,
};
const Patients = ({ t, history }) => {
  const cachedActiveTab = getStorage(constants.patientsList.cache.patientList);
  const { isStaff, isOwner } = useAccountOwnerCommon();
  let { officeId } = useParams();
  const [enabledTabs, setEnabledTabs] = useState(0);
  const decodeOfficeId = parseInt(decodeId(officeId));
  const profile = useSelector((state) => state.userProfile.profile);
  const { isLoading: isLoadingOfficeDetail, data: officeDetail } =
    useOfficeDetail(decodeOfficeId);
  const { isLoading: isLoadingStaffDetail, data: staffDetail } =
    useStaffByUserId(decodeOfficeId, profile?.id);
  const [activeTab, setActiveTab] = useState(
    cachedActiveTab?.activeTab
      ? cachedActiveTab.activeTab
      : staffDetail?.isAdmin || profile?.isAccountOwnerSetup
        ? 1
        : 2,
  );
  const valueFromAdminScreen = useMemo(() => {
    const value = getStorage("patient_from_admin");
    if (isStaff && value == 1) {
      return true;
    }
    return false;
  }, [isStaff]);
  let isFromStaffAdmin = getStorage(constants.notes.cache.isFromStaffAdmin);
  const isfromappointmentdashboard = getStorage(
    "is-from-appointment-dashboard",
  );
  const tabName = constants.patientsTab;
  useEffect(() => {
    if (cachedActiveTab?.activeTab) {
      setActiveTab(cachedActiveTab?.activeTab);
      return;
    }
    
    // owner
    if (isOwner) {
      setActiveTab(tabName.myPatients);
      setEnabledTabs(tabsEnabled.both);
      return;
    }
    // only receptionist
    if (
      !valueFromAdminScreen &&
      !staffDetail?.isDoctor &&
      staffDetail?.isReceptionist
    ) {
      setActiveTab(tabName.otherDoctors);
      setEnabledTabs(tabsEnabled.otherDoctors);
      return;
    }

    // only doctor
    if (
      !valueFromAdminScreen &&
      staffDetail?.isDoctor &&
      !staffDetail?.isReceptionist
    ) {
      setActiveTab(tabName.myPatients);
      setEnabledTabs(tabsEnabled.mypatient);
      return;
    }
    // only admin
    if (
      valueFromAdminScreen &&
      staffDetail?.isAdmin &&
      !staffDetail?.isDoctor &&
      !staffDetail?.isReceptionist
    ) {
      setActiveTab(tabName.otherDoctors);
      setEnabledTabs(tabsEnabled.otherDoctors);
      return;
    }
    // admin and receptionist
    if (
      valueFromAdminScreen &&
      staffDetail?.isAdmin &&
      !staffDetail?.isDoctor &&
      staffDetail?.isReceptionist
    ) {
      setActiveTab(tabName.otherDoctors);
      setEnabledTabs(tabsEnabled.otherDoctors);
      return;
    }
    // admin and doctor
    if (
      valueFromAdminScreen &&
      staffDetail?.isAdmin &&
      staffDetail?.isDoctor &&
      !staffDetail?.isReceptionist
    ) {
      setActiveTab(tabName.myPatients);
      setEnabledTabs(tabsEnabled.both);
      return;
    }
  }, [staffDetail, profile?.isAccountOwnerSetup, isOwner,valueFromAdminScreen]);
  const goToPreviousScreen = () => {
    if (isfromappointmentdashboard) {
      history.push(
        constants.routes.superAdmin.appointmentDashboard.replace(
          ":officeId",
          officeId,
        ),
      );
      return;
    }
    if (profile?.role?.systemRole === constants.systemRoles.accountOwner) {
      history.push(
        constants.routes.accountOwner.officeOptions.replace(
          ":officeId",
          officeId,
        ),
      );
    } else if (staffDetail?.isAdmin) {
      const route = isFromStaffAdmin
        ? constants.routes.staff.officeOptions
        : constants.routes.staff.officeAdmin;
      history.push(route.replace(":officeId", officeId));
    } else {
      history.push(
        constants.routes.staff.officeOptions.replace(":officeId", officeId),
      );
    }
  };

  const manageTab = (tab) => {
    window.scrollTo(0, 0);
    setActiveTab(tab);
    setStorage(constants.patientsList.cache.eventlisting, {
      activeTab: tab,
    });
  };
  const doctorTabEnabled = activeTab === tabName.otherDoctors;
  const cannotCreateAppointMentDirectly =
    isStaff &&
    (valueFromAdminScreen
      ? staffDetail?.isAdmin
      : staffDetail?.isReceptionist) &&
    !staffDetail?.isDoctor;
  const canCreateAppointMentDirectly =
    isOwner || (isStaff && staffDetail?.isDoctor);
  const canCreateAppointMent =
    canCreateAppointMentDirectly || cannotCreateAppointMentDirectly;
  const doctorSelectionScreen =
    cannotCreateAppointMentDirectly ||
    (canCreateAppointMentDirectly && doctorTabEnabled);
  const bothTabEnabled = enabledTabs === tabsEnabled.both;
  return (
    <Page className="scheduler-page" onBack={goToPreviousScreen}>
      {(isLoadingOfficeDetail || isLoadingStaffDetail) && <Loader />}
      <div className="d-flex justify-content-between align-items-center marginBottom30">
        <div className={styles["first-row-text-part"]}>
          <p className="page-title page_title_margin_top">
            {t("patients.patients")}
          </p>
          <Text size="14px" color="#000000" weight="300" className="sub-title">
            {" "}
            {officeDetail?.name}{" "}
          </Text>
        </div>
        {canCreateAppointMent && (
          <div className={styles["btn-box"]}>
            <Link
              to={{
                pathname: doctorSelectionScreen
                  ? constants.routes.appointment.doctorSelection
                      .replace(":officeId", officeId)
                      .replace("/:patientId?", "")
                  : constants.routes.appointment.patientNewAppointment
                      .replace(":officeId?", officeId)
                      .replace(":doctorId?", encodeId(profile.id))
                      .replace("/:patientId?", ""),
                state: {
                  isfromPatientListing: true,
                },
              }}
            >
              <button className="button button-round button-shadow w-sm-100">
                {t("patientAppointmentMembers.addAppointment")}
              </button>
            </Link>
          </div>
        )}
      </div>
      <Card className="card_with_tabs">
        <div className="common-tabs scheduler-tabs">
          {bothTabEnabled && (
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={activeTab === tabName.myPatients ? "active" : ""}
                  onClick={() => manageTab(1)}
                >
                  {t("patients.myPatients")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === tabName.otherDoctors ? "active" : ""}
                  onClick={() => manageTab(2)}
                >
                  {t("patients.otherDoctors")}
                </NavLink>
              </NavItem>
            </Nav>
          )}
          <TabContent activeTab={activeTab}>
            <Suspense fallback={<Loader />}>
              <TabPane tabId={1}>
                {(bothTabEnabled || enabledTabs === tabsEnabled.mypatient) &&
                  activeTab === tabName.myPatients && (
                    <PatientList
                      isMyPatients={true}
                      staffDetail={staffDetail}
                      canCreateAppointMent={canCreateAppointMent}
                      cannotCreateAppointMentDirectly={
                        cannotCreateAppointMentDirectly
                      }
                    />
                  )}
              </TabPane>
              <TabPane tabId={2}>
                {(bothTabEnabled || enabledTabs === tabsEnabled.otherDoctors) &&
                  doctorTabEnabled && (
                    <PatientList
                      isMyPatients={false}
                      staffDetail={staffDetail}
                      canCreateAppointMent={canCreateAppointMent}
                      cannotCreateAppointMentDirectly={true}
                    />
                  )}
              </TabPane>
            </Suspense>
          </TabContent>
        </div>
      </Card>
    </Page>
  );
};
export default withTranslation()(Patients);
